import React, { useEffect, useState } from 'react';
import { MdOutlineFileUpload, MdClose } from 'react-icons/md';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';

const Banner = () => {
  const [imagePreview, setImagePreview] = useState(null);
  const [planData, setPlanData] = useState({ file: null });
  const [loader, setLoader] = useState(false);
  const [banner, setBanner] = useState([]);

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = () => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/admin/banner', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setBanner(data?.data);
      })
      .catch((error) => console.error(error));
  };

  const handleClick = () => {
    document.getElementById('fileInput').click();
  };

  const handleRemoveImage = () => {
    setPlanData((prev) => ({
      ...prev,
      file: null
    }));
    setImagePreview(null);
    document.getElementById('fileInput').value = ''; // Clear the file input
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setPlanData((prev) => ({
        ...prev,
        file: file
      }));
      setImagePreview(URL.createObjectURL(file));

      // Automatically trigger the upload process
      await uploadFile(file);
    }
  };

  const uploadFile = async (file) => {
    setLoader(true);

    const formdata = new FormData();
    formdata.append('images', file);

    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    try {
      const response = await fetch(
        'https://file-upload-ashen.vercel.app/api/upload',
        requestOptions
      );
      const result = await response.text();
      let data = JSON.parse(result);

      if (data?.success === true) {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Accept', 'application/json');
        myHeaders.append('Access-Control-Allow-Origin', '*');

        const raw = JSON.stringify({
          images: data?.data[0]
        });

        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };

        const bannerResponse = await fetch(
          'https://quran-backend-theta.vercel.app/v1/admin/banner',
          requestOptions
        );
        const bannerResult = await bannerResponse.text();
        let bannerData = JSON.parse(bannerResult);

        setLoader(false);

        if (bannerData?.success === false) {
          if (bannerData?.message === 'Expired') {
            localStorage.clear();
            window.location.reload();
          } else {
            toast.error(bannerData?.message);
          }
        } else {
          toast.success('File uploaded successfully!');
          fetchBanners();
        }
      } else {
        setLoader(false);
        toast.error('Having Problem In Uploading Image');
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
      toast.error('An error occurred while uploading the image');
    }
  };

  const handleDeleteBanner = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        deleteBanner(id);
      }
    });
  };

  const deleteBanner = async (id) => {
    const requestOptions = {
      method: 'DELETE',
      redirect: 'follow'
    };

    try {
      const response = await fetch(
        `https://quran-backend-theta.vercel.app/v1/admin/banner/${id}`,
        requestOptions
      );
      const result = await response.text();
      let data = JSON.parse(result);

      if (data?.success === true) {
        toast.success('Banner deleted successfully!');
        fetchBanners();
      } else {
        toast.error('Failed to delete banner');
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while deleting the banner');
    }
  };

  return (
    <div className="mt-4 bg-[#FAFAFA] w-full p-4 rounded-lg">
      <div className="flex justify-between items-center">
        <h6 className="text-[#1C1D1D] text-xl font-semibold">Banners</h6>
      </div>

      <div className="flex pt-3 gap-2 justify-start flex-wrap">
        {banner?.map((item, index) => (
          <div key={index} className="relative w-64 h-64">
            <img src={item?.images} className="w-full h-full rounded-lg" alt="" />
            <div className="flex justify-center gap-3 pt-3">
              <div className="bg-white w-10 rounded-full flex justify-center items-center h-10 shadow-lg cursor-pointer">
                <img src={require('../../assets/image/edit.png')} alt="Edit" />
              </div>
              <div
                className="bg-white rounded-full flex justify-center items-center w-10 h-10 shadow-lg cursor-pointer"
                onClick={() => handleDeleteBanner(item._id)}
              >
                <img src={require('../../assets/image/del.png')} alt="Delete" />
              </div>
            </div>
          </div>
        ))}
        <div className="mx-auto w-full mt-16">
          <div
            className="w-96 mx-auto border-dashed border-[#9E9E9E] border-2 rounded-lg p-4 cursor-pointer"
            onClick={handleClick}
          >
            <div className="bg-[#F6F6F6] mx-auto w-14 flex justify-center items-center h-14 rounded-2xl">
              <MdOutlineFileUpload size={30} className="text-primary" />
            </div>
            <p className="text-primary font-medium mt-3 text-center">
              <span className="text-secondary">Click here</span> to upload or drop CNIC
            </p>

            {imagePreview && (
              <div className="relative w-full h-32 mt-4">
                <img
                  src={imagePreview}
                  alt="Selected Image"
                  className="w-full h-full object-cover rounded-md"
                />
                <button
                  type="button"
                  onClick={handleRemoveImage}
                  className="absolute top-0 right-0 bg-red-500 text-white p-2 rounded-full"
                >
                  <MdClose size={20} />
                </button>
              </div>
            )}
            <input
              id="fileInput"
              type="file"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
          </div>
          {loader && <div className="mt-4 text-center text-blue-500">Uploading...</div>}
        </div>
      </div>
    </div>
  );
};

export default Banner;
